module.exports = __webpack_public_path__ + "static/img/fu_zhuang_fu_shi_.16f35b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fu_zhuang_fu_shi_.png
// module id = jtzJ
// module chunks = 18